import { Component, computed, inject, Signal, ChangeDetectionStrategy } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MatDivider } from '@angular/material/divider'
import { MatIcon } from '@angular/material/icon'
import { Principal, PrincipalService } from '@elderbyte/ngx-auth'
import {
  ElderNavGroupComponent,
  ElderNavLinkComponent,
  ElderNavListComponent,
  ElderNavModule,
  UrlBuilder,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { environment } from '../../../environments/environment'
import { Facility } from '../../domain/facilities/facility'
import { map } from 'rxjs'
import { FacilityContextService } from '../../domain/context/facility-context/facility-context.service'

@Component({
  selector: 'app-main-nav-menu',
  templateUrl: './main-nav-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ElderNavModule,
    ElderNavGroupComponent,
    ElderNavLinkComponent,
    ElderNavListComponent,
    MatDivider,
    MatIcon,
    ElderTranslatePipe,
  ],
})
export class MainNavMenuComponent {
  public readonly principal: Signal<Principal>

  public readonly isPrincipalOwner = computed(() => this.principal()?.hasRole('OWNER'))
  public readonly isPrincipalSiteManager = computed(() => this.principal()?.hasRole('SITE_MANAGER'))
  public readonly storageManagementUrl: Signal<string>

  constructor() {
    const principalService = inject(PrincipalService)
    const facilityContextService = inject(FacilityContextService)

    this.principal = toSignal(principalService.principalObservable)

    const storageManagementUrl$ = facilityContextService.facility$.pipe(
      map((facility) => this.buildStorageManagementUrl(facility))
    )
    this.storageManagementUrl = toSignal(storageManagementUrl$)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private buildStorageManagementUrl(facility: Facility): string {
    return UrlBuilder.parse(environment.storageManagementUrl)
      .setParam('path', facility.id.toUpperCase())
      .build()
  }
}
